import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import CheckoutTransparente from './CheckoutTransparente';
import './Cart.css';

const Cart = () => {
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const {
    cartItems,
    removeFromCart,
    updateQuantity,
    getTotal,
    isCartOpen,
    setIsCartOpen,
    toggleCart
  } = useCart();

  const handleCheckout = () => {
    setIsCartOpen(false);
    setIsCheckoutOpen(true);
  };

  if (!isCartOpen) return (
    <>
      <CheckoutTransparente isOpen={isCheckoutOpen} onClose={() => setIsCheckoutOpen(false)} />
    </>
  );

  return (
    <>
      <CheckoutTransparente isOpen={isCheckoutOpen} onClose={() => setIsCheckoutOpen(false)} />
      <div className="cart-overlay" onClick={toggleCart}></div>
      <div className="cart-sidebar">
        <div className="cart-header">
          <h2 className="cart-title">TU CARRITO</h2>
          <button className="cart-close" onClick={toggleCart}>✕</button>
        </div>

        {cartItems.length === 0 ? (
          <div className="cart-empty">
            <div className="cart-empty-icon">🛒</div>
            <p className="cart-empty-text">Tu carrito está vacío</p>
            <button className="btn-continuar-comprando" onClick={toggleCart}>
              CONTINUAR COMPRANDO
            </button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cartItems.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="cart-item-imagen">
                    <img src={item.imagen} alt={item.nombre} />
                  </div>
                  <div className="cart-item-info">
                    <h4 className="cart-item-nombre">{item.nombre}</h4>
                    <p className="cart-item-linea">{item.linea}</p>
                    <p className="cart-item-precio">${item.precio}</p>
                  </div>
                  <div className="cart-item-actions">
                    <div className="cart-item-cantidad">
                      <button
                        className="btn-cantidad-cart"
                        onClick={() => updateQuantity(item.id, item.cantidad - 1)}
                      >
                        −
                      </button>
                      <span className="cantidad-numero-cart">{item.cantidad}</span>
                      <button
                        className="btn-cantidad-cart"
                        onClick={() => updateQuantity(item.id, item.cantidad + 1)}
                      >
                        +
                      </button>
                    </div>
                    <button
                      className="btn-remover"
                      onClick={() => removeFromCart(item.id)}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="cart-subtotal">
                <span className="cart-subtotal-label">Subtotal:</span>
                <span className="cart-subtotal-precio">${getTotal().toFixed(0)}</span>
              </div>
              <div className="cart-envio-info">
                <p>Envío calculado en el checkout</p>
              </div>
              <button className="btn-checkout" onClick={handleCheckout}>
                FINALIZAR COMPRA
              </button>
              <button className="btn-seguir-comprando" onClick={toggleCart}>
                Seguir comprando
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Cart;
